export const renderStyleSheet = () => {
    const defaultCSSFile = "sidebar-keego.css"

    const cssFile = defaultCSSFile

    import(`../Layouts/Sidebar/${cssFile}`)
}
